import { AngularFireStorageModule } from '@angular/fire/storage';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireModule } from '@angular/fire';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireFunctionsModule } from '@angular/fire/functions';
import { MatPaginatorModule } from '@angular/material/paginator';
import { AgmCoreModule } from '@agm/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  AngularFireAnalyticsModule,
  ScreenTrackingService,
} from '@angular/fire/analytics';
import {
  AngularFirePerformanceModule,
  PerformanceMonitoringService,
} from '@angular/fire/performance';
import { TeximateModule } from 'ngx-teximate';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { RxReactiveFormsModule } from '@rxweb/reactive-form-validators';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgAisModule } from 'angular-instantsearch';
import { UiModule } from '@monorepo/ui';

import { HeaderModule } from './modules/header/header.module';
import { FooterModule } from './modules/footer/footer.module';
import { AppRoutingModule } from './app-routing.module';
import { ListingModule } from './modules/listing/listing.module';
import { LocationDetailsModule } from './modules/location-details/location-details.module';
import { LoginModule } from './modules/login/login.module';
import { ApprovalsModule } from './modules/approvals/approvals.module';
import { UiChatBotModule } from '@monorepo/ui/chat-bot';
import { MobileFixedMenuModule } from '@monorepo/ui';

import { AppComponent } from './app.component';

import { environment } from '../environments/environment';
import { MessageService } from 'primeng/api';

@NgModule({
  declarations: [AppComponent],
  imports: [
    HeaderModule,
    FooterModule,
    BrowserModule,
    BrowserAnimationsModule,
    RxReactiveFormsModule,
    NgAisModule.forRoot(),
    TeximateModule,
    AppRoutingModule,
    LoginModule,
    ListingModule,
    LocationDetailsModule,
    FomanticUIModule,
    ApprovalsModule,
    MatSidenavModule,
    AngularFireModule.initializeApp(environment.firebase), // imports firebase/app needed for everything
    AngularFirestoreModule.enablePersistence(), // imports firebase/firestore, only needed for database features
    AngularFireAuthModule, // imports firebase/auth, only needed for auth features,
    AngularFireStorageModule, // imports firebase/storage only needed for storage features
    AngularFireAnalyticsModule,
    AngularFirePerformanceModule,
    AngularFireFunctionsModule,
    UiChatBotModule,
    MatPaginatorModule,
    UiModule,
    MobileFixedMenuModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyARVBihC9LV7YMunZXKkVPHDaCeDDJwczQ',
      libraries: ['places'],
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
    }),
  ],
  providers: [
    ScreenTrackingService,
    PerformanceMonitoringService,
    MessageService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
